import {Keywords} from 'components/Keywords/Keywords';
import {KeywordFields} from 'components/Keywords/keywordItem.types';
import React, {useCallback} from 'react';
import {Keyword, KeywordSuggestion} from 'types';

type MyKeywords = Keyword[] | undefined;

interface Props {
	myKeywords: MyKeywords;
	paragraphKeywords: KeywordFields[];
	suggestions?: KeywordSuggestion[];
}

export function ParagraphListKeywords({
	myKeywords,
	paragraphKeywords,
	suggestions,
}: Props): React.ReactElement {
	const getStyles = useCallback(
		(keyword: KeywordFields) => {
			if (keyword.isSuggestion === true) {
				return {
					root: {
						border: '1px solid red',
						backgroundColor: '#FFCCCC',
					},
				};
			}
			if (myKeywords?.some(k => k.id === keyword.id)) {
				return {
					root: {
						border: '1px solid black',
					},
				};
			}
			return undefined;
		},
		[myKeywords],
	);

	return (
		<Keywords
			keywords={paragraphKeywords}
			suggestions={suggestions}
			getTextStyles={getStyles}
		/>
	);
}
